// AEQUUS scroll reveal
(function () {
  // Mark body so CSS can enable opacity-0 initial states
  document.documentElement.classList.add('aeq-js');

  if (!('IntersectionObserver' in window)) {
    // No support — make everything visible immediately
    document.querySelectorAll('.aeq-reveal, .aeq-stagger').forEach(function(el) {
      el.classList.add('is-visible');
    });
    return;
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.aeq-reveal, .aeq-stagger').forEach(function(el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0, rootMargin: '0px 0px -60px 0px' }
  );

  document.querySelectorAll('.aeq-reveal, .aeq-stagger').forEach(function(el) {
    observer.observe(el);
  });
})();
